export default {
      id: "whatsapp-list-item-usage",
      viewBox: "0 0 18 18",
      url: __webpack_public_path__ + "sprite-46b249.svg#whatsapp-list-item-usage",
      toString: function () {
        return this.url;
      }
    }